import { Component, Input } from '@angular/core';
import { BaseModalService, CustomerInquiryOfferListItemResponse, CustomerOfferResponse, InquiryResponse } from 'base';
import { Router } from '@angular/router';

@Component({
  selector: 'base-customer-offer-information-tab',
  templateUrl: './base-customer-offer-information-tab.component.html',
})
export class BaseCustomerOfferInformationTabComponent {
  @Input() offer: (CustomerInquiryOfferListItemResponse & { order?: number }) | CustomerOfferResponse;
  @Input() inquiry: InquiryResponse;
  @Input({ required: true }) locationId: number;

  constructor(private router: Router, private modalService: BaseModalService) {}

  openIzsInfoModal(event: Event): void {
    event.stopPropagation();
    this.modalService.closeAllModals();
    this.router.navigate(['/service-provider'], {
      queryParams: {
        page: 1,
        search: this.offer.pspBranch.name,
        pspBranchId: this.offer.pspBranch.id,
        location: this.locationId,
      },
    });
  }
}
